"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var material_1 = require("@mui/material");

var style_1 = require("./style");

var Avatar = function (props) {
  var badge = props.badge,
      small = props.small,
      testid = props.testid;

  var defaultProps = __assign({
    css: small ? style_1.styles.small : null,
    "data-testid": testid
  }, props);

  return react_1["default"].createElement(react_1["default"].Fragment, null, badge ? react_1["default"].createElement(style_1.StyledBadge, {
    overlap: "circular",
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    variant: "dot"
  }, react_1["default"].createElement(material_1.Avatar, __assign({}, defaultProps))) : react_1["default"].createElement(material_1.Avatar, __assign({}, defaultProps)));
};

exports["default"] = Avatar;